<template>
    <div>
        <el-tabs v-model="activeTab" type="border-card" lazy>
            <el-tab-pane :label="$t('Summary')" name="first">
                <el-form
                    :label-width="!$client.isMobile ? '200px' : '100px'"
                    label-position="left"
                    :model="riskImprovement"
                    :rules="rules"
                    :validate-on-rule-change="false"
                    ref="form"
                >
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item :label="$t('Factor')" prop="factor">
                                <el-select
                                    v-model="riskImprovement.factor"
                                    filterable
                                    :placeholder="$t('Type in to filter factor')"
                                    class="w-100"
                                    size="small"
                                    :disabled="isQRA"
                                >
                                    <el-option
                                        v-for="item in factorList"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item :label="$t('Heading')" prop="heading">
                                <el-input
                                    :disabled="!editable"
                                    :placeholder="$t('Heading')"
                                    v-model="riskImprovement.heading"
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item :label="$t('Description')" prop="ri_description">
                                <el-input
                                    :disabled="!editable"
                                    :placeholder="$t('Description')"
                                    v-model="riskImprovement.ri_description"
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item :label="$t('Category')" prop="category">
                                <el-select
                                    :disabled="!editable"
                                    v-model="riskImprovement.category"
                                    filterable
                                    :placeholder="$t('Type in to filter category')"
                                    class="w-100"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in CATEGORY_LIST"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('Priority')" prop="priority">
                                <el-select
                                    :disabled="!editable"
                                    v-model="riskImprovement.priority"
                                    filterable
                                    :placeholder="$t('Type in to filter priority')"
                                    class="w-100"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in PRIORITY_LIST"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item :label="$t('Risk Improvements')" prop="ri_comment">
                                <htmleditor
                                    :editable="editable"
                                    v-model="riskImprovement.ri_comment"
                                    class="w-100"
                                ></htmleditor>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item :label="$t('Deficiency')" prop="def_comment">
                                <htmleditor
                                    :editable="editable"
                                    v-model="riskImprovement.def_comment"
                                    class="w-100"
                                ></htmleditor>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item :label="$t('Estimate')" prop="cost_estimate">
                                <el-select
                                    :disabled="!editable"
                                    v-model="riskImprovement.cost_estimate"
                                    filterable
                                    :placeholder="$t('Select')"
                                    class="w-100"
                                    size="small"
                                >
                                    <el-option
                                        v-for="item in COST_ESTIMATE_LIST"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('Actual')" prop="cost_actual">
                                <numberfield
                                    :disabled="!editable"
                                    :placeholder="$t('Actual')"
                                    v-model="riskImprovement.cost_actual"
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="showMitigated">
                        <el-col :span="12">
                            <el-form-item :label="$t('At Survey')" prop="risk_rating_at_survey">
                                <numberfield
                                    disabled
                                    :placeholder="$t('At Survey')"
                                    v-model="riskImprovement.risk_rating_at_survey"
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('Mitigated')" prop="risk_rating_mitigated">
                                <numberfield
                                    :disabled="!editable"
                                    :placeholder="$t('Mitigated')"
                                    v-model="riskImprovement.risk_rating_mitigated"
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item :label="$t('EML Block')" prop="eml_block">
                                <el-radio-group
                                    v-model="riskImprovement.eml_block"
                                    :disabled="!editable"
                                >
                                    <el-radio label="Primary">{{ $t('Primary') }} </el-radio>
                                    <el-radio label="Other">{{ $t('Other') }} </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row :span="24">
                    <div style="float: right; padding-left: 5px">
                        <el-button
                            :disabled="!editable"
                            v-if="riskImprovement.id"
                            size="small"
                            type="primary"
                            :loading="loading"
                            @click="onAddComment(false)"
                        >
                            <template>
                                <i class="fa fa-edit"></i>
                                {{ $t('Change Status') }}</template
                            >
                        </el-button>

                        <el-button
                            :disabled="!editable"
                            size="small"
                            type="primary"
                            :loading="loading"
                            @click="onSave(false)"
                        >
                            <template v-if="riskImprovement.id">
                                <i class="fa fa-edit"></i>
                                {{ $t('Update') }}</template
                            >
                            <template v-else>
                                <i class="fa fa-save"></i>
                                {{ $t('Save') }}</template
                            >
                        </el-button>
                    </div>
                </el-row>
                <div>
                    <el-card shadow>
                        <el-table
                            ref="table"
                            class="w-100"
                            :data="riskImprovementLogList"
                            :loading="loading"
                        >
                            <template>
                                <el-table-column :label="$t('Status')">
                                    <template slot-scope="scope">
                                        <div class="text-overflow-ellipsis">
                                            <el-select
                                                :disabled="!!scope.row.id"
                                                v-model="scope.row.ri_status"
                                                filterable
                                                :placeholder="$t('Select')"
                                                class="w-100"
                                                size="small"
                                            >
                                                <el-option
                                                    v-for="item in STATUS_LIST"
                                                    :key="item.id"
                                                    :label="item.label"
                                                    :value="item.id"
                                                >
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('Date Updated')">
                                    <template slot-scope="scope">
                                        <div class="text-overflow-ellipsis">
                                            {{
                                                moment(scope.row.record_date_utc)
                                                    .locale(langCode)
                                                    .format('lll')
                                            }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('Updated By')">
                                    <template slot-scope="scope">
                                        <div class="text-overflow-ellipsis">
                                            {{ getUserName(scope.row.user) }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('Comments')">
                                    <template slot-scope="scope">
                                        <div class="text-overflow-ellipsis">
                                            <el-input
                                                :disabled="!!scope.row.id"
                                                v-model="scope.row.ri_comment"
                                                size="small"
                                                class="w-100"
                                            />
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('Completion Date')">
                                    <template slot-scope="scope">
                                        <div class="text-overflow-ellipsis">
                                            {{ scope.row.user.completion_date_utc }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column>
                                    <template slot-scope="scope">
                                        <div class="row-actions">
                                            <el-button
                                                :disabled="!editable"
                                                v-if="!scope.row.id"
                                                size="small"
                                                type="primary"
                                                class="bg-shadow"
                                                @click="onSaveLog(scope.row)"
                                            >
                                                <i class="fa fa-save"></i>
                                            </el-button>
                                            <el-button
                                                :disabled="!editable"
                                                size="small"
                                                type="primary"
                                                class="bg-shadow"
                                                @click="onRemove(scope.row)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table>
                    </el-card>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('Photos')" name="second">
                <fileuploader
                    :readonly="!editable"
                    :ref_id="riskImprovement.id"
                    ref_table="form_ques_data_ri"
                    :files="riskImprovement.files"
                    :owner="riskImprovement"
                ></fileuploader>
            </el-tab-pane>
            <el-tab-pane v-if="showLeTab" :label="$t('Loss Estimates')" name="third">
                <el-card shadow="never">
                    <el-form
                        :label-width="!$client.isMobile ? '200px' : '100px'"
                        label-position="left"
                        :model="riskImprovement"
                        :validate-on-rule-change="false"
                        ref="form"
                    >
                        <el-row :gutter="10">
                            <el-col :span="15">
                                <el-form-item :label="$t('Same as CNLE')">
                                    <el-checkbox
                                        :disabled="!editable"
                                        v-model="riskImprovement.same_as_cnle"
                                        @change="onSameAsCnleChange"
                                        :true-label="1"
                                        :false-label="0"
                                        size="small"
                                    >
                                    </el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item :label="$t('PROPERTY DAMAGE')"> </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item :label="$t('AT SURVEY IN CNLE')"> </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item :label="$t('Building')" prop="building_ratio">
                                    <numberfield
                                        :disabled="!leEditable"
                                        v-model="riskImprovement.lossEstimate.cnle.building_ratio"
                                        size="small"
                                    >
                                        <template slot="append">%</template>
                                    </numberfield>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" class="el-form-item__content">
                                <numberfield
                                    disabled
                                    size="small"
                                    :value="
                                        calcValue(
                                            'prieml',
                                            'cnle',
                                            'building_value',
                                            'building_ratio',
                                            'building_value'
                                        )
                                    "
                                >
                                    <template slot="append">{{ customerCurrency }}</template>
                                </numberfield>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item
                                    :label="$t('Plant and equipment')"
                                    prop="plant_equipment_ratio"
                                >
                                    <numberfield
                                        :disabled="!leEditable"
                                        v-model="
                                            riskImprovement.lossEstimate.cnle.plant_equipment_ratio
                                        "
                                        size="small"
                                    >
                                        <template slot="append">%</template>
                                    </numberfield>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" class="el-form-item__content">
                                <!-- v-model="riskImprovement.lossEstimate.cnle.plant_equipment_value" -->
                                <numberfield
                                    disabled
                                    size="small"
                                    class="el-form-item__content"
                                    :value="
                                        calcValue(
                                            'prieml',
                                            'cnle',
                                            'plant_equipment_value',
                                            'plant_equipment_ratio',
                                            'plant_equipment_value'
                                        )
                                    "
                                >
                                    <template slot="append">{{ customerCurrency }}</template>
                                </numberfield>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item :label="$t('Stock')" prop="stock_ratio">
                                    <numberfield
                                        :disabled="!leEditable"
                                        v-model="riskImprovement.lossEstimate.cnle.stock_ratio"
                                        size="small"
                                    >
                                        <template slot="append">%</template>
                                    </numberfield>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" class="el-form-item__content">
                                <numberfield
                                    disabled
                                    size="small"
                                    class="el-form-item__content"
                                    :value="
                                        calcValue(
                                            'prieml',
                                            'cnle',
                                            'stock_value',
                                            'stock_ratio',
                                            'stock_value'
                                        )
                                    "
                                >
                                    <template slot="append">{{ customerCurrency }}</template>
                                </numberfield>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item :label="$t('Other')" prop="other_ratio">
                                    <numberfield
                                        :disabled="!leEditable"
                                        v-model="riskImprovement.lossEstimate.cnle.other_ratio"
                                        size="small"
                                    >
                                        <template slot="append">%</template>
                                    </numberfield>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" class="el-form-item__content">
                                <numberfield
                                    disabled
                                    size="small"
                                    :value="
                                        calcValue(
                                            'prieml',
                                            'cnle',
                                            'other_value',
                                            'other_ratio',
                                            'other_value'
                                        )
                                    "
                                >
                                    <template slot="append">{{ customerCurrency }}</template>
                                </numberfield>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item :label="$t('BUSINESS INTERRUPTION')"> </el-form-item>
                            </el-col>
                        </el-row>
                        <!-- todo rsa musa tam olarak cnle i hangi kolona denkgeliyor -->
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item :label="$t('Estimated BI')" prop="estimated_bi">
                                    <numberfield
                                        :disabled="!leEditable"
                                        v-model="
                                            riskImprovement.lossEstimate.cnle.total_bi_le_ratio
                                        "
                                        size="small"
                                    >
                                        <template slot="append">{{ $t('days') }}</template>
                                    </numberfield>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" class="el-form-item__content">
                                <numberfield
                                    disabled
                                    size="small"
                                    :value="
                                        calcLEValue30(
                                            'prieml',
                                            'cnle',
                                            'total_bi_le_value',
                                            'total_bi_le_ratio',
                                            'total_bi_le_value'
                                        )
                                    "
                                >
                                    <template slot="append">{{ customerCurrency }}</template>
                                </numberfield>
                            </el-col>
                        </el-row>
                        <!-- todo rsa musa nasil hesaplaniyor -->
                        <el-row :gutter="10">
                            <el-col :span="15" class="el-form-item__content">
                                <el-form-item :label="$t('TOTAL')" prop="estimated_bi">
                                    <!-- v-model="riskImprovement.lossEstimate.cnle.total_pd_bi_le" -->

                                    <numberfield
                                        disabled
                                        size="small"
                                        class="el-form-item__content"
                                        :value="
                                            calcTotalPdBiLossEstimates(
                                                riskImprovement.lossEstimate.cnle
                                            )
                                        "
                                    >
                                        <template slot="append">{{ customerCurrency }}</template>
                                    </numberfield>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import moment from 'moment-timezone';
import { DEFAULT_ERROR_MESSAGE } from '@app/common/utils/constants';
import RiskImprovement from '@/data/RiskImprovement';
import RiskImprovementLog from '@/data/RiskImprovementLog';

// import FormQuestion from '@/data/FormQuestion';
import VisitQraCnle from '@/data/VisitQraCnle';
import Collection from '@/lib/data/Collection';
import eventBus from '@app/src/lib/helpers/eventbus';
import Htmleditor from '../htmleditor/htmleditor.vue';
import fileuploader from '../uwscreens/fileuploader.vue';
import numberfield from '../inspection/numberfield.vue';
import { CATEGORY_LIST, PRIORITY_LIST, STATUS_LIST, COST_ESTIMATE_LIST } from './data';

export default {
    name: 'riskimppanel',
    components: { Htmleditor, fileuploader, numberfield },
    props: {
        value: Boolean,
        question: { /* type: FormQuestion, */ required: true },
        riskImprovement: {
            type: RiskImprovement,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        visit: null,
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            activeTab: 'first',
            loading: false,
            moment,
            cnle_value: new VisitQraCnle(),
            factorList: new Collection({
                url: '/forms/factorlist',
                method: 'GET',
            }),
            CATEGORY_LIST,
            PRIORITY_LIST,
            COST_ESTIMATE_LIST,
            STATUS_LIST,
        };
    },
    created() {},
    mounted() {
        this.loadFactorList();
        this.riskImprovement.files.load(true, {
            params: { id: this.riskImprovement.id },
        });
        if (this.isQRA) {
            this.riskImprovement.factor = this.riskImprovement.factor || this.question.caption;
        }
    },
    computed: {
        showMitigated() {
            return this.isQRA;
        },
        isQRA() {
            return this.question?.control_name?.indexOf('QRA') > -1;
        },
        visitId() {
            return this.visit.id;
        },
        showLeTab() {
            return (
                this.riskImprovement.category == 'CAT 1' || this.riskImprovement.category == 'CAT 2'
            );
        },
        leEditable() {
            return !this.riskImprovement.same_as_cnle && this.editable;
        },
        customerCurrency() {
            return this.visit?.customer?.currency_name;
        },
        langCode() {
            return window.localStorage.language_code;
        },
        riskImprovementLogList() {
            return this.riskImprovement.risk_improvement_log_list;
        },
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        context() {
            return this.$store.getters.context;
        },
        user() {
            return this.$store.getters.context.user;
        },
        rules() {
            return {
                factor: [
                    {
                        required: true,
                        message: this.$t('Please select factor'),
                        trigger: ['blur', 'change'],
                    },
                ],
                heading: [
                    {
                        required: true,
                        message: this.$t('Please enter heading'),
                        trigger: ['blur', 'change'],
                    },
                ],
                category: [
                    {
                        required: true,
                        message: this.$t('Please select category'),
                        trigger: ['blur', 'change'],
                    },
                ],
                priority: [
                    {
                        required: true,
                        message: this.$t('Please select priority'),
                        trigger: ['blur', 'change'],
                    },
                ],
                ri_comment: [
                    {
                        required: true,
                        message: this.$t('Please enter risk improvements'),
                        trigger: ['blur', 'change'],
                    },
                ],
                def_comment: [
                    {
                        required: true,
                        message: this.$t('Please enter deficiency'),
                        trigger: ['blur', 'change'],
                    },
                ],
            };
        },
        calcValue() {
            return (oper1, oper2, input1, input2, output) => {
                const data = this.riskImprovement.lossEstimate;
                data[oper2][output] = parseFloat(
                    ((data[oper1][input1] * data[oper2][input2]) / 100)?.toFixed(2)
                );
                return data[oper2][output] || null;
            };
        },
        calcLEValue30() {
            return (oper1, oper2, input1, input2, output) => {
                const data = this.riskImprovement.lossEstimate;
                data[oper2][output] = parseFloat(
                    (
                        (data[oper1][input1] * data[oper2][input2]) /
                        (30 * data.tsi.indemnity_period)
                    )?.toFixed(2)
                );
                return data[oper2][output] || null;
            };
        },
        quesMitigatedValue() {
            return parseInt(JSON.parse(this.question?.data?.return_value)?.mitigated || 0, 10) || 0;
        },
    },
    watch: {
        'question.data.id': {
            immediate: true,
            handler(v) {
                this.riskImprovement.form_ques_data_id = v;
            },
        },
        'question.data': {
            immediate: true,
            handler(v) {
                this.riskImprovement.risk_rating_at_survey = JSON.parse(v?.return_value)?.at_survey;
            },
        },
    },
    methods: {
        getUserName(user) {
            return user.first_name ? `${user.first_name} ${user.last_name || ''}` : user.full_name;
        },
        calcTotalPDLossEstimates(column) {
            column.total_pd_le =
                (column.building_value || 0) +
                    (column.plant_equipment_value || 0) +
                    (column.stock_value || 0) +
                    (column.other_value || 0) || null;
            return column.total_pd_le;
        },
        calcTotalPdBiLossEstimates(column) {
            this.calcTotalPDLossEstimates(column);
            column.total_pd_bi_le =
                parseFloat(
                    ((column.total_pd_le || 0) + (column.total_bi_le_value || 0))?.toFixed(2)
                ) || null;
            return column.total_pd_bi_le;
        },
        onSameAsCnleChange(val) {
            if (val) {
                this.cnle_value.read({
                    params: {
                        visit_id: this.visitId,
                    },
                    success: () => {
                        this.riskImprovement.loss_estimate = this.cnle_value.loss_estimate_value;
                    },
                    complete: () => {
                        this.loading = false;
                    },
                });
            }
        },
        loadFactorList() {
            // QRA.. tipinde bir soru ise ayni tipdeki questionlarin captionlari
            if (this.isQRA) {
                this.factorList.load(
                    true,
                    {
                        params: { visit_id: this.visitId },
                    },
                    {
                        beforesend: () => {
                            this.modalLoading = true;
                        },
                        complete: () => {
                            this.modalLoading = false;
                        },
                    }
                );
            } else {
                // yoksa form_ques icinde taninlanmis olan factorler
                this.factorList = this.question?.factors?.map((x) => ({
                    id: x.label,
                    label: x.label,
                }));
            }
        },
        onRemove(item) {
            this.$confirm(this.$t('Are you sure you want to remove?'), this.$t('Warning'), {
                confirmButtonText: this.$t('Yes'),
                cancelButtonText: this.$t('Cancel'),
                type: 'warning',
            }).then(() => {
                item.remove({
                    beforesend: () => {
                        this.loading = true;
                    },
                    complete: () => {
                        this.loading = false;
                    },
                    success: () => {
                        // this.loadAccounts();
                        this.riskImprovementLogList.remove(item);
                    },
                    failure: (_, response) => {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message:
                                response && response.meta
                                    ? response.meta.display_message
                                    : this.$t(DEFAULT_ERROR_MESSAGE),
                        });
                    },
                });
            });
        },
        onAddComment() {
            const riskImprovementLog = new RiskImprovementLog();
            riskImprovementLog.form_ques_data_ri_id = this.riskImprovement.id;
            riskImprovementLog.record_date_utc = new Date();
            riskImprovementLog.user = this.user;

            this.riskImprovementLogList.push(riskImprovementLog);
        },

        onSaveLog(item) {
            item.create({
                beforesend: () => {
                    this.loading = true;
                },
                complete: () => {
                    this.loading = false;
                },
                success: () => {
                    this.riskImprovement.status = item.ri_status;
                    this.$notify.success({
                        title: this.$parent.$t('Success'),
                        message: this.$parent.$t('Record saved successfully'),
                    });
                },
                failure: (_, response) => {
                    this.$notify.error({
                        title: this.$t('Error'),
                        message:
                            response && response.meta
                                ? response.meta.display_message
                                : this.$t(DEFAULT_ERROR_MESSAGE),
                    });
                },
            });
        },
        onSave() {
            if (!this.checkMitigatedSum()) {
                this.$notify.error({
                    title: this.$t('Error'),
                    message: this.$t(
                        'Sum of mitigated values can not be greater than QRA mitigated value'
                    ),
                });
            } else {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        // if (this.question?.data?.id) {
                        //     saveRiskImprovement(this, this.question, this.riskImprovement);
                        // } else {
                        eventBus.$emit('saveRiskImprovement', this.question, this.riskImprovement);
                        // }
                    }
                });
            }
        },
        checkMitigatedSum() {
            const olderMitigatedValues = this.question.data.risk_improvements.reduce(
                (acc, cur) => parseInt(acc || 0, 10) + parseInt(cur.risk_rating_mitigated || 0, 10),
                0
            );
            // current mitigated value and older mitigated values can not be greater than question mitigated value.
            return (
                this.quesMitigatedValue >=
                olderMitigatedValues + (this.riskImprovement.risk_rating_mitigated || 0)
            );
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@/styles/responsive.scss';
</style>
